import type { CakeFilling } from "../CakeFilling.js";
import type { CakeFillingOption } from "../CakeFillingOption.js";
import type { Category } from "../Category.js";
import { Locale } from "../Locale.js";
import type { Product, ProductForCustomer } from "../Product.js";
import { namesOfRequiredCategories } from "../namesOfRequiredCategories.js";

export function getFillingCategory(categories: Category[]): Category | undefined {
	return categories.find(({ name }) => name[Locale.cs] === namesOfRequiredCategories.fillings[Locale.cs]);
}

export function getCakeFillingProducts<TProduct extends Product | ProductForCustomer>(
	products: TProduct[],
	categories: Category[],
	locale: Locale,
): TProduct[] {
	const fillingCategory = getFillingCategory(categories);
	if (!fillingCategory) {
		return [];
	}

	return products
		.filter(
			({ categoryIds, offeredAsCakeFilling, soldOut }) =>
				offeredAsCakeFilling && !soldOut && categoryIds.includes(fillingCategory.id),
		)
		.toSorted((first, second) => first.name[locale].localeCompare(second.name[locale], locale));
}

export function getCakeCategory(categories: Category[]): Category | undefined {
	return categories.find(({ name }) => name[Locale.cs] === namesOfRequiredCategories.cakes[Locale.cs]);
}

export function productsToCakeFillingOptions(products: (Product | ProductForCustomer)[]): CakeFillingOption[] {
	return products.map((product) => ({
		productId: product.id,
		name: product.name,
		isDefault: product.isDefaultCakeFilling,
	}));
}

export function getDefaultCakeFilling(fillings: CakeFillingOption[]): CakeFilling | undefined {
	const filling = fillings.find(({ isDefault }) => isDefault) ?? fillings[0];
	if (!filling) {
		return undefined;
	}

	return { productId: filling.productId, name: filling.name };
}
